module.exports = __webpack_public_path__ + "img/page-05.2078495e.jpg";